import styled from 'styled-components';

export const Wrapper = styled.section`
  height: 100vh;
  overflow: auto;
  padding: 25px;
`;
